import { AbstractControl } from '@angular/forms';
import { Observable } from 'rxjs';

export function convertSnaps<T>(results: any) {
  return <T[]>results.map((snap: any) => ({ id: snap.payload.key, ...snap.payload.val() }));
}

export const WEEK_DAYS = [
  { name: 'Lunes', code: 'monday' },
  { name: 'Martes', code: 'tuesday' },
  { name: 'Miércoles', code: 'wednesday' },
  { name: 'Jueves', code: 'thursday' },
  { name: 'Viernes', code: 'friday' },
  { name: 'Sábado', code: 'saturday' },
  { name: 'Domingo', code: 'sunday' },
];

export const DATE_MINUTES = [
  { name: '15min', code: 15 },
  { name: '30min', code: 30 },
  { name: '60min', code: 60 },
];

export const findDateMinutesByCode = (code: number) => {
  return DATE_MINUTES.find((item) => item.code === code);
};

export function generateSlug(text: string): string {
  return text
    .toLowerCase() // Convertir a minúsculas
    .normalize('NFD') // Normalizar el texto en forma de descomposición
    .replace(/[\u0300-\u036f]/g, '') // Eliminar marcas diacríticas (acentos)
    .replace(/ñ/g, 'n') // Reemplazar "ñ" por "n"
    .replace(/[^a-z0-9 -]/g, '') // Eliminar caracteres especiales restantes
    .replace(/\s+/g, '-') // Reemplazar espacios por guiones
    .replace(/-+/g, '-'); // Reemplazar múltiples guiones por uno solo
}

export function validateImage(control: AbstractControl): { [key: string]: any } | null {
  const file = control.value;
  if (file) {
    const allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
    const maxSize = 5 * 1024 * 1024; // 5MB

    if (!allowedExtensions.exec(file.name)) {
      return { invalidFileType: true };
    }

    if (file.size > maxSize) {
      return { invalidFileSize: true };
    }
  }
  return null;
}

export function generatePreview(file: File): Observable<string | ArrayBuffer | null> {
  return new Observable<string | ArrayBuffer | null>((observer) => {
    const reader = new FileReader();
    reader.onload = (e: ProgressEvent<FileReader>) => {
      observer.next(e.target?.result ?? null);
      observer.complete();
    };
    reader.onerror = (error) => {
      observer.error(error);
      observer.complete();
    };
    reader.readAsDataURL(file);
  });
}

export function removeCountryCode(phoneNumber: string) {
  const countryCodePattern = /^\+\d{2}/;
  const phoneNumberWithoutCountryCode = phoneNumber.replace(countryCodePattern, '');
  return phoneNumberWithoutCountryCode;
}
